export default "__VITE_ASSET__CYle7flm__"